<div class="winners-podium-wrapper">
  <div class="winner-place-wrapper second">
    <div class="winner-number-wrapper">
      @if (myScore !== secondPlaceScore) {
        <div class="label-h4 number">2</div>
      }
      @if (myScore === secondPlaceScore) {
        <img lib-amdocs-image-version src="/assets/icons/click-and-win/small-crown.svg" />
      }
    </div>
    <div class="winner-box">
      <div class="label-h1 score">{{secondPlaceScore}}</div>
    </div>
  </div>
  <div class="winner-place-wrapper first">
    <div class="winner-number-wrapper">
      @if (myScore !== firstPlaceScore) {
        <div class="label-h4 number">1</div>
      }
      @if (myScore === firstPlaceScore) {
        <img lib-amdocs-image-version src="/assets/icons/click-and-win/crown.svg" />
      }
    </div>
    <div class="winner-box">
      <div class="label-h1 score">{{firstPlaceScore}}</div>
    </div>
  </div>
  <div class="winner-place-wrapper third">
    <div class="winner-number-wrapper">
      @if (myScore !== thirdPlaceScore) {
        <div class="label-h4 number">3</div>
      }
      @if (myScore === thirdPlaceScore) {
        <img lib-amdocs-image-version  src="/assets/icons/click-and-win/small-crown.svg">
      }
    </div>

    <div class="winner-box">
      <div class="label-h1 score">{{thirdPlaceScore}}</div>
    </div>
  </div>
</div>
